/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M11.1643.161a2.2499 2.2499 0 0 1 1.6712 0l9.9964 3.9985a1.8576 1.8576 0 0 1 1.1678 1.7418v11.7173a2.25 2.25 0 0 1-1.4144 2.089l-9.7498 3.9a2.2505 2.2505 0 0 1-1.6712 0l-9.7499-3.9a2.2498 2.2498 0 0 1-1.4143-2.089V5.9014a1.8577 1.8577 0 0 1 1.1678-1.7419L11.1643.1609Zm1.1141 1.3926 9.8894 3.9558-9.8894 3.9557a.75.75 0 0 1-.5571 0L1.832 5.5094l9.8893-3.9558a.75.75 0 0 1 .5571 0ZM1.5001 17.6186V6.9921l9.6642 3.8657a2.206 2.206 0 0 0 .0856.0322v11.1363L1.9715 18.315a.75.75 0 0 1-.4714-.6964Zm11.2498 4.4077 9.2784-3.7113a.75.75 0 0 0 .4714-.6964V6.9921l-9.6642 3.8657a2.2692 2.2692 0 0 1-.0856.0322v11.1363Z"
    clipRule="evenodd"
  />,
  'Package'
);
